import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { extractTicketFieldsForSelectedTicket, getDecisionNodeAtPath } from '../../../../extractFromState';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Container, Title, Info, Row, Arrow, FieldName, FieldValue } from './DTTicketFieldsWidget.styles';

const DTTicketFieldsWidget = () => {
  const decisionNode = useSelector(getDecisionNodeAtPath);
  const ticketFields = useSelector(extractTicketFieldsForSelectedTicket);

  const [fields, setFields] = useState([]);

  useEffect(() => {
    const ticketFieldsWidget = get(decisionNode, 'ticketFieldsWidget', []);

    if (isEmpty(ticketFieldsWidget)) {
      return setFields(ticketFields);
    }

    const filteredTicketFields = ticketFields.filter((field) => ticketFieldsWidget.includes(field.title));
    setFields(filteredTicketFields);
  }, [decisionNode, ticketFields]);

  return (
    <Container>
      <Title>Ticket Info</Title>
      {isEmpty(fields) && <Info>No data to display</Info>}
      {fields.map((field) => (
        <Row key={field.title}>
          <FieldName>{field.title}</FieldName>
          <Arrow alt="arrow" src="/images/arrows/arrow-widget.svg" />
          <FieldValue>{field.value}</FieldValue>
        </Row>
      ))}
    </Container>
  );
};

export default DTTicketFieldsWidget;
